import { isEmpty } from "lodash";
import React from "react";

const RenderBookmakerOdds = ({
  component,
  handelChange,
  odds_lay,
  odds_back,
  item,
  limit,
  disabelBack,
  disabelLay,
  conditionNew,
  oldBack,
  oldLay,
  disableFull,
  ms,
  betType,
  active,
}) => {
  let checkDisabled = (odds) => {
    if (Number(odds) > 0) {
      if (Number(odds) > limit?.oddsLimit) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  };
  let check = (odds) => {
    if (!conditionNew) {
      if (Number(odds) > 0 || !isEmpty(odds)) {
        if (Number(odds) > limit?.oddsLimit) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    } else {
      return false;
    }
  };
  return (
    <div
      data-v-d884c596
      className="w-4/12 relative grid grid-cols-2 gap-x-2 bg-bookmaker-market p-1 rounded-md self-start"
    >
      {odds_back?.length > 0 ? (
        odds_back?.slice(0, 1)?.map((res, id) => {
          let chamak =
            oldBack?.length > 0
              ? res?.rt != oldBack[id]?.rt || res?.bv != oldBack[id]?.bv
              : false;
          return (
            <div
              onClick={(e) => {
                if (disabelBack) {
                } else {
                  if (!checkDisabled(res?.rt)) {
                    handelChange(
                      res,
                      "back",
                      item?.RunnerName || item?.runnerName,
                      item,e
                    );
                  }
                }
              }}
              style={check(res?.rt) ? { cursor: "not-allowed" } : {}}
              data-v-754343ce
              data-v-d884c596
              className={`h-30px text-center rounded-md border border-white flex items-center justify-center active-text-white bg-back-300 ${
                active && betType == "back" ? "back-active" : ""
              }`}
              title="BACK"
              betinfoid="3100-BACK"
            >
              <h3 data-v-754343ce className="text-15">
                {res?.rt || ""}
              </h3>
            </div>
          );
        })
      ) : (
        <div
          data-v-754343ce
          data-v-d884c596
          className={`h-30px text-center rounded-md border border-white flex items-center justify-center active-text-white bg-back-300`}
          title="BACK"
          betinfoid="3100-BACK"
        >
          <h3 data-v-754343ce className="text-15" />
        </div>
      )}
      {odds_lay?.length > 0 ? (
        odds_lay?.slice(0, 1)?.map((res, id) => {
          let chamak =
            oldLay?.length > 0
              ? res?.rt != oldLay[id]?.rt || res?.bv != oldLay[id]?.bv
              : false;
          return (
            <div
              onClick={(e) => {
                if (disabelLay) {
                } else {
                  if (!checkDisabled(res?.rt)) {
                    handelChange(
                      res,
                      "lay",
                      item?.RunnerName || item?.runnerName,
                      item,e
                    );
                  }
                }
              }}
              style={check(res?.rt) ? { cursor: "not-allowed" } : {}}
              data-v-754343ce
              data-v-d884c596
              className={`h-30px text-center rounded-md border border-white flex items-center justify-center active-text-white bg-lay-300 ${
                active && betType == "lay" ? "lay-active" : ""
              } `}
              title="LAY"
              betinfoid="3100-LAY"
            >
              <h3 data-v-754343ce className="text-15">
                {" "}
                {res?.rt || ""}
              </h3>
            </div>
          );
        })
      ) : (
        <div
          data-v-754343ce
          data-v-d884c596
          className={`h-30px text-center rounded-md border border-white flex items-center justify-center active-text-white bg-lay-300`}
          title="LAY"
          betinfoid="3100-LAY"
        >
          <h3 data-v-754343ce className="text-15"></h3>
        </div>
      )}
      {disableFull && ms == 1 && (
        <div class="absolute right-0 top-0 flex justify-center items-center w-full h-full bg-black-700 opacity-80 text-11 text-white rounded-md">
          Suspended
        </div>
      )}
    </div>
  );
};

export default RenderBookmakerOdds;
